import { type IBase } from "@/interfaces/api/base.interface"
import { type Moment } from "moment"

export interface ISurchargePeriod extends IBase {
  periodStart: Moment
  periodEnd: Moment
  surchargePercent: string | undefined
  surchargePerUnit: string | undefined
  surchargeFlat: string | undefined
}
